import React from 'react';

import Button from 'components/Button';

import './styles.css';

const AffordabilityDocumentUploadButtons = ({
  submitForm,
  submitDisabled,
  submitting
}) => (
  <div className="AffordabilityDocumentUploadButtons">
    <Button
      blue={!submitDisabled}
      className="submit"
      onClick={submitForm}
      isLoading={submitting}
      disabled={submitDisabled}>
      Save
    </Button>
  </div>
);

export default AffordabilityDocumentUploadButtons;
